import { ApolloClientType } from "../../types/apollo";

export const clearQuestionsFromCache = async (client: ApolloClientType) => {
  await client.clearStore();

  if (client.persistor) {
    await client.persistor.purge();
  }
};
